module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.launchedFromClinProps && _vm.clinFetchingGtrData),
      expression: "launchedFromClinProps && clinFetchingGtrData"
    }]
  }, [_c('LoadingTemplate')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.clinFetchingGtrData),
      expression: "!clinFetchingGtrData"
    }],
    staticStyle: {
      "background-color": "#f9fbff"
    }
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.y === 'top',
      "bottom": _vm.y === 'bottom',
      "right": _vm.x === 'right',
      "left": _vm.x === 'left',
      "multi-line": _vm.mode === 'multi-line',
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.snackbarText) + "\n          "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticStyle: {
      "margin-bottom": "-5px"
    }
  }, [_c('h3', [_vm._v("Genetic Testing Registry")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": "",
      "lg8": "",
      "xl8": ""
    }
  }, [_c('DisorderSearch', {
    attrs: {
      "DisordersPropsBackArr": _vm.DisordersPropsBackArr,
      "launchedFromClinProps": _vm.launchedFromClinProps,
      "clinSearchedGtr": _vm.clinSearchedGtr
    },
    on: {
      "showDiseases": function($event) {
        _vm.addDiseases($event)
      },
      "multipleSearchData": function($event) {
        _vm.multipleSearchData($event)
      },
      "search-gtr": _vm.onSearchGTR
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [(_vm.geneProps.length && _vm.modeOfInheritanceProps.length && _vm.multipleSearchItems.length) ? _c('div', {
    staticClass: "d-flex mb-2 xs12 mb-3 genes-card-placeholder"
  }, [_c('v-card', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('v-card-text', [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("\n                                    GENES\n                                  ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.GtrGenesTabNumber))]), _vm._v(" of " + _vm._s(_vm.TotalGtrGenes) + " genes selected\n                                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [(_vm.TotalGtrGenes > 0) ? _c('progressCircularDonut', {
    attrs: {
      "selectedNumber": _vm.GtrGenesTabNumber,
      "totalNumber": _vm.TotalGtrGenes
    }
  }) : _vm._e()], 1)], 1)], 1)], 1) : (_vm.geneProps.length === 0 && _vm.modeOfInheritanceProps.length && _vm.multipleSearchItems.length) ? _c('div', {
    staticClass: "d-flex mb-2 xs12 mb-3"
  }, [_c('v-card', {
    staticClass: "activeCardBox"
  }, [_c('v-card-text', [_c('center', [_c('label', [_vm._v("Genes")]), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v("0")]), _vm._v(" of 0 genes selected\n                                  ")])], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(!_vm.disordersSearchedByUser) ? _c('div', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(_vm.IntroductionTextData.Title))])]), _vm._v(" "), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.IntroductionTextData.Content)
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md8": "",
      "lg8": ""
    }
  }, [_c('v-card', [_c('ContentLoaderPlaceholder', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentPlaceHolder),
      expression: "contentPlaceHolder"
    }]
  }), _vm._v(" "), (_vm.geneProps.length && _vm.diseasesProps.length && _vm.modeOfInheritanceProps.length && _vm.multipleSearchItems.length) ? _c('show-gene-panel1', {
    attrs: {
      "GeneData": _vm.geneProps,
      "modeOfInheritanceData": _vm.modeOfInheritanceProps,
      "multipleSearchItems": _vm.multipleSearchItems,
      "geneSearch": _vm.geneSearch,
      "launchedFromClinProps": _vm.launchedFromClinProps,
      "clinGenes": _vm.clinGenes,
      "associatedGenes": _vm.associatedGenes
    },
    on: {
      "UpdateSelectedGenesText": function($event) {
        _vm.ChangeSelectedGenesText($event)
      },
      "NoOfGenesSelectedFromGTR": function($event) {
        _vm.UpdateNoOfGenesSelectedFromGTR($event)
      },
      "TotalNoOfGenesFromGTR": function($event) {
        _vm.TotalNoOfGenesFromGTR($event)
      },
      "SelectedGenesToCopy": function($event) {
        _vm.UpdateListOfSelectedGenes($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.geneProps.length === 0 && _vm.modeOfInheritanceProps.length && _vm.multipleSearchItems.length) ? _c('div', [_c('NoGenesDisplayTable')], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "positionModal"
  }, [_c('v-dialog', {
    staticStyle: {
      "height": "initial !important"
    },
    attrs: {
      "width": "450",
      "content-class": "positionModal"
    },
    model: {
      value: (_vm.openFilterDialog),
      callback: function($$v) {
        _vm.openFilterDialog = $$v
      },
      expression: "openFilterDialog"
    }
  }, [_c('v-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chartComponent === 'disorders'),
      expression: "chartComponent==='disorders'"
    }],
    class: [_vm.chartComponent === 'disorders' ? 'activeClass' : 'disabledClass']
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": function($event) {
        _vm.DisordersAndModesComponent = 'disorders'
      }
    }
  }, [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                                  ASSOCIATED CONDITIONS & MODES OF INHERITANCE\n                                ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selectDisorders.length))]), _vm._v(" of " + _vm._s(_vm.multiSelectDisorder.length) + " conditions selected\n                                ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBoxInside",
      "selectedNumber": _vm.selectDisorders.length,
      "totalNumber": _vm.multiSelectDisorder.length
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('center', [_c('strong', [_vm._v("ASSOCIATED CONDITIONS")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('center', [_c('strong', [_vm._v("GENES")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "vendorsCardClass"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, _vm._l((_vm.multiSelectDisorder), function(item, i) {
    return _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('v-tooltip', {
      attrs: {
        "left": "",
        "nudge-right": "180"
      }
    }, [_c('v-checkbox', {
      staticStyle: {
        "margin-top": "-8px"
      },
      attrs: {
        "slot": "activator",
        "label": item.Title,
        "value": item
      },
      slot: "activator",
      model: {
        value: (_vm.selectDisorders),
        callback: function($$v) {
          _vm.selectDisorders = $$v
        },
        expression: "selectDisorders"
      }
    }), _vm._v(" "), _c('span', [_c('center', [_c('strong', [_vm._v(_vm._s(item.Title))])]), _vm._v(" "), _c('br'), _vm._v("\n                                          Mode of inheritance: " + _vm._s(item._modeOfInheritance) + "\n                                          "), _c('br'), _vm._v("\n                                          Gene Panels: " + _vm._s(item._genePanelCount) + "\n                                          "), _c('br')], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('div', [(_vm.TotalGtrGenes > 0 && _vm.chartComponent === 'disorders') ? _c('DisordersGeneBar', {
      staticClass: "SvgBarClass",
      attrs: {
        "id": "disordersGeneBar",
        "selectedNumber": item._geneCount,
        "totalNumber": _vm.maxGenes
      }
    }) : _vm._e()], 1)])], 1)
  }))], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.SelectAllDisordersButton
    }
  }, [_vm._v("SELECT ALL")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.DeSelectAllDisordersButton
    }
  }, [_vm._v("DESELECT ALL")])], 1)], 1)], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": function($event) {
        _vm.DisordersAndModesComponent = 'modes'
      }
    }
  }, [_c('center', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selectedModesOfInheritance.length))]), _vm._v(" of " + _vm._s(_vm.modeOfInheritanceProps.length) + " modes of inheritance selected\n                                ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "ModesOfInheritanceSvgBox",
      "selectedNumber": _vm.selectedModesOfInheritance.length,
      "totalNumber": _vm.modeOfInheritanceProps.length
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n                                Each condition is associated with one or more modes of inheritance. If a mode of inheritance is selected below,\n                                all conditions associated with it will be retained. If a condition is associated with multiple modes of inheritance,\n                                all must be deselected to remove the condition.\n                              ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('center', [_c('strong', [_vm._v("MODE OF INHERITANCE")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('center', [_c('strong', [_vm._v("CONDITIONS")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "vendorsCardClass"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, _vm._l((_vm.modeOfInheritanceProps), function(item, i) {
    return _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs7": ""
      }
    }, [_c('v-checkbox', {
      staticStyle: {
        "margin-top": "-5px"
      },
      attrs: {
        "label": item._modeOfInheritance,
        "value": item._modeOfInheritance
      },
      model: {
        value: (_vm.selectedModesOfInheritance),
        callback: function($$v) {
          _vm.selectedModesOfInheritance = $$v
        },
        expression: "selectedModesOfInheritance"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('div', [(_vm.multiSelectDisorder.length > 0 && _vm.chartComponent === 'disorders') ? _c('ModesSvgBar', {
      staticClass: "SvgBarClass",
      attrs: {
        "id": "ModesGeneBar",
        "selectedNumber": item._numberOfDisorder,
        "totalNumber": _vm.multiSelectDisorder.length
      }
    }) : _vm._e()], 1)])], 1)
  }))], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.SelectAllModesButton
    }
  }, [_vm._v("SELECT ALL")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.DeSelectAllModesButton
    }
  }, [_vm._v("DESELECT ALL")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('center', [_c('v-btn', {
    attrs: {
      "color": "primary darken-1",
      "flat": "flat"
    },
    on: {
      "click": _vm.closeComponent
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chartComponent === 'GeneMembership'),
      expression: "chartComponent==='GeneMembership'"
    }],
    class: [_vm.chartComponent === 'GeneMembership' ? 'activeClass' : 'disabledClass']
  }, [(_vm.vendorList.length) ? _c('div', [_c('v-card-text', [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading"
  }, [_vm._v("\n                                  PANELS\n                                ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selectedPanelsInCheckBox.length))]), _vm._v(" of " + _vm._s(_vm.multiSelectPanels.length) + " panels selected\n                                ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [(_vm.multiSelectPanels.length) ? _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "panelsSvgBoxInside",
      "selectedNumber": _vm.selectedPanelsInCheckBox.length,
      "totalNumber": _vm.multiSelectPanels.length
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("PANELS")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("GENES")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('center', [_c('strong', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("CONDITIONS")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPanelsCardData),
      expression: "showPanelsCardData"
    }],
    staticClass: "vendorsCardClass",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, _vm._l((_vm.multiSelectPanels), function(item, i) {
    return _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-checkbox', {
      staticStyle: {
        "margin-top": "-8px"
      },
      attrs: {
        "label": item.testname,
        "value": item
      },
      model: {
        value: (_vm.selectedPanelsInCheckBox),
        callback: function($$v) {
          _vm.selectedPanelsInCheckBox = $$v
        },
        expression: "selectedPanelsInCheckBox"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs1": ""
      }
    }, [_c('center', {
      staticStyle: {
        "margin-top": "-6px"
      }
    }, [(item.filter === 'specific') ? _c('span', [_c('strong', {
      staticStyle: {
        "margin-top": "-6px",
        "font-size": "14px",
        "color": "green"
      }
    }, [_vm._v("\n                                            " + _vm._s(item.genecount) + "\n                                          ")])]) : (item.filter === 'moderate') ? _c('span', [_c('strong', {
      staticStyle: {
        "margin-top": "-6px",
        "font-size": "14px",
        "color": "#FFAB00"
      }
    }, [_vm._v("\n                                            " + _vm._s(item.genecount) + "\n                                          ")])]) : (item.filter === 'general') ? _c('span', [_c('strong', {
      staticStyle: {
        "margin-top": "-6px",
        "font-size": "14px",
        "color": "red"
      }
    }, [_vm._v("\n                                            " + _vm._s(item.genecount) + "\n                                          ")])]) : _vm._e()])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('center', [(_vm.chartComponent === 'GeneMembership') ? _c('PanelsConditions', {
      attrs: {
        "selectedNumber": item._diseaseCount,
        "totalNumber": _vm.multiSelectDisorder.length
      }
    }) : _vm._e()], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.SelectAllPanels
    }
  }, [_vm._v("SELECT ALL")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.DeSelectAllPanels
    }
  }, [_vm._v("DESELECT ALL")])], 1)], 1)], 1), _vm._v(" "), _c('br')], 1)], 1) : _vm._e(), _vm._v(" "), _c('center', [_c('v-btn', {
    attrs: {
      "color": "primary darken-1",
      "flat": "flat"
    },
    on: {
      "click": _vm.closeComponent
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chartComponent === 'Vendors'),
      expression: "chartComponent==='Vendors'"
    }],
    class: [_vm.chartComponent === 'Vendors' ? 'activeClass' : 'disabledClass']
  }, [(_vm.multiSelectItems.length) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading"
  }, [_vm._v("\n                                VENDORS\n                              ")]), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), (_vm.multiSelectItems.length > 1) ? _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.vendorsSelect.length))]), _vm._v(" of " + _vm._s(_vm.multiSelectItems.length) + " vendors selected\n                                ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBoxInside",
      "selectedNumber": _vm.vendorsSelect.length,
      "totalNumber": _vm.multiSelectItems.length
    }
  })], 1)], 1)], 1)], 1) : (_vm.multiSelectItems.length < 2) ? _c('div', [(_vm.selectedPanelsInCheckBox.length > 0) ? _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v("1")]), _vm._v(" of 1 vendor selected\n                                  ")]), _vm._v(" "), _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBoxInside",
      "selectedNumber": 1,
      "totalNumber": 1
    }
  })], 1) : (_vm.selectedPanelsInCheckBox.length < 1) ? _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v("0")]), _vm._v(" of 1 vendor selected\n                                  ")]), _vm._v(" "), _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBoxInside",
      "selectedNumber": 0,
      "totalNumber": 1
    }
  })], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.multiSelectItems.length > 1) ? _c('div', {
    staticClass: "vendorsCardClass",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, _vm._l((_vm.multiSelectItems), function(item, i) {
    return _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-checkbox', {
      staticStyle: {
        "margin-top": "-8px"
      },
      attrs: {
        "label": item,
        "value": item
      },
      model: {
        value: (_vm.vendorsSelect),
        callback: function($$v) {
          _vm.vendorsSelect = $$v
        },
        expression: "vendorsSelect"
      }
    })], 1)], 1)
  }))], 1) : (_vm.multiSelectItems.length < 2) ? _c('div', {
    staticClass: "vendorsCardClass"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs,sm,md,lg,xl": ""
    }
  }, _vm._l((_vm.multiSelectItems), function(item, i) {
    return _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": ""
      }
    }, [_c('strong', {
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('p', [_vm._v(_vm._s(item))])])])], 1)
  }))], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.multiSelectItems.length > 1) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.SelectAllVendors
    }
  }, [_vm._v("SELECT ALL")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('center', [_c('v-btn', {
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": _vm.DeSelectAllVendors
    }
  }, [_vm._v("DESELECT ALL")])], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('center', [_c('v-btn', {
    attrs: {
      "color": "primary darken-1",
      "flat": "flat"
    },
    on: {
      "click": _vm.closeComponent
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('br')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    class: [(_vm.browser === 'Chrome' && _vm.isMobile === false) || (_vm.browser === 'Firefox' && _vm.isMobile === false) ? 'flex xs12 sm12 md4 lg4 pr-2 pl-2' : 'flex xs12 sm12 md2 lg3 pr-2 pl-2']
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentPlaceHolder),
      expression: "contentPlaceHolder"
    }]
  }, [_c('div', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('ContentLoaderSidebar')], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('ContentLoaderSidebar')], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('ContentLoaderSidebar')], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "activeFilterCard"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "inActiveDisordersAndModesFilterCard"
    }
  }, [_c('div', {
    staticClass: "mb-3",
    attrs: {
      "id": "activeDisordersAndModesFilterCard"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.diseases.length && _vm.modeOfInheritanceProps.length > 0) ? _c('div', [_c('v-card', {
    class: [_vm.chartComponent === 'disorders' ? 'activeCardBox elevation-5' : 'rightbarCard ']
  }, [_c('v-card-text', [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                              ASSOCIATED CONDITIONS & MODES OF INHERITANCE\n                            ")]), _vm._v(" "), _c('Dialogs', {
    staticClass: "dialogBox",
    attrs: {
      "id": "disordersDialog",
      "HeadlineText": _vm.HelpDialogsData[2].HeadlineText,
      "ContentText": _vm.HelpDialogsData[2].Content
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selectDisorders.length))]), _vm._v(" of " + _vm._s(_vm.multiSelectDisorder.length) + " conditions selected\n                             ")]), _vm._v(" "), _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBox",
      "selectedNumber": _vm.selectDisorders.length,
      "totalNumber": _vm.multiSelectDisorder.length
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selectedModesOfInheritance.length))]), _vm._v(" of " + _vm._s(_vm.modeOfInheritanceProps.length) + " modes of inheritance selected\n                             ")]), _vm._v(" "), _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "ModesOfInheritanceSvgBox",
      "selectedNumber": _vm.selectedModesOfInheritance.length,
      "totalNumber": _vm.modeOfInheritanceProps.length
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chartComponent !== 'disorders'),
      expression: "chartComponent!=='disorders'"
    }],
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showChartComponent('disorders')
      }
    }
  }, [_vm._v("\n                               View & Filter\n                             ")])], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "inActivePanelsFilterCard"
    }
  }, [_c('div', {
    staticClass: "mb-3",
    attrs: {
      "id": "activePanelsFilterCard"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.diseasesProps.length && _vm.modeOfInheritanceProps.length) ? _c('div', [_c('v-card', {
    class: [_vm.chartComponent === 'GeneMembership' ? 'activeCardBox elevation-5' : 'rightbarCard ']
  }, [_c('v-card-text', [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading"
  }, [_vm._v("\n                              PANELS\n                            ")]), _vm._v(" "), _c('Dialogs', {
    staticClass: "dialogBox",
    attrs: {
      "id": "GeneMembershipDialog",
      "HeadlineText": _vm.HelpDialogsData[3].HeadlineText,
      "ContentText": _vm.HelpDialogsData[3].Content
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), (_vm.diseases.length && _vm.modeOfInheritanceProps.length > 0) ? _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_vm._v(" Selection")]), _vm._v(" "), (!_vm.editPanelDefinition) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "activator"
    },
    on: {
      "click": _vm.openEditPanelsDefinitionModal
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('span', [_vm._v("Edit Panels Definition")])]) : _vm._e(), _vm._v(" "), _c('span', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.editPanelDefinition),
      callback: function($$v) {
        _vm.editPanelDefinition = $$v
      },
      expression: "editPanelDefinition"
    }
  }, [_c('div', [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("EDIT PANEL DEFINITION")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "-4px"
    }
  }), _vm._v(" "), (_vm.panelsAlert) ? _c('Alerts', {
    attrs: {
      "alertType": "warning",
      "alertTransition": "scale-transition",
      "alertText": _vm.panelAlertText
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify",
      "margin-top": "-20px"
    }
  }, [_vm._v("\n                                        Panels are classified into three categories:\n                                        ")]), _c('p', [_c('strong', [_c('div', {
    staticStyle: {
      "height": "12px",
      "width": "12px",
      "display": "inline-block",
      "background-color": "green"
    }
  }), _vm._v("   Specific panels ")]), _vm._v("  typically target specific conditions, and so contain fewer genes.\n                                        ")]), _vm._v(" "), _c('p', [_c('strong', [_c('div', {
    staticStyle: {
      "height": "12px",
      "width": "12px",
      "display": "inline-block",
      "background-color": "red"
    }
  }), _vm._v("   General panels ")]), _vm._v("  are used to test for many different conditions and consequently contain a relatively large number of genes.\n                                        ")]), _vm._v(" "), _c('p', [_c('strong', [_c('div', {
    staticStyle: {
      "height": "12px",
      "width": "12px",
      "display": "inline-block",
      "background-color": "#ffab00"
    }
  }), _vm._v("   Moderate panels ")]), _vm._v("  are intermediate to these extremes.\n                                        ")]), _vm._v("\n                                        The panels are defined by the number of genes they cover, and can be edited by using the slider below.\n                                      "), _c('p')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "margin-left": "50px"
    },
    attrs: {
      "id": "EditCard"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-3"
  }, [_c('v-range-slider', {
    attrs: {
      "max": 100,
      "min": 0,
      "step": 1,
      "thumb-label": "always",
      "track-color": "green",
      "color": "amber accent-4",
      "thumb-color": "primary"
    },
    model: {
      value: (_vm.panelsDefinitionValues),
      callback: function($$v) {
        _vm.panelsDefinitionValues = $$v
      },
      expression: "panelsDefinitionValues"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-28px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "-2.4px",
      "color": "#a5a5a5"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "338px",
      "color": "#a5a5a5"
    }
  }, [_vm._v("|")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "display": "inline",
      "margin-left": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "id": "position0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "330px",
      "font-size": "12px"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "27px"
    }
  }, [_vm._v("∞")])]), _vm._v(" "), (!_vm.showPanelsDistribution) ? _c('p', [_c('center', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "color": "gray darken-4"
    },
    on: {
      "click": function($event) {
        _vm.showPanelsDistribution = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "gray darken-4"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" Show Panels Distribution "), _c('v-icon', {
    attrs: {
      "color": "gray darken-4"
    }
  }, [_vm._v("keyboard_arrow_down")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPanelsDistribution) ? _c('v-card-text', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Panels Distribution: ")]), _vm._v(" "), _c('br'), _vm._v("\n                                      - Specific panels contain less than "), _c('strong', {
    staticStyle: {
      "color": "rgb(132, 132, 132)"
    }
  }, [_vm._v(_vm._s(_vm.panelsDefinitionValues[0]))]), _vm._v(" genes\n                                      "), _c('br'), _vm._v("\n                                      - Moderate panels contain between "), _c('strong', {
    staticStyle: {
      "color": "rgb(132, 132, 132)"
    }
  }, [_vm._v(_vm._s(_vm.panelsDefinitionValues[0]))]), _vm._v(" and "), _c('strong', {
    staticStyle: {
      "color": "rgb(132, 132, 132)"
    }
  }, [_vm._v(_vm._s(_vm.panelsDefinitionValues[1]))]), _vm._v(" genes\n                                      "), _c('br'), _vm._v("\n                                      - General panels contain more than "), _c('strong', {
    staticStyle: {
      "color": "rgb(132, 132, 132)"
    }
  }, [_vm._v(_vm._s(_vm.panelsDefinitionValues[1]))]), _vm._v(" genes\n                                      "), _c('br'), _c('br'), _vm._v(" "), _c('center', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "color": "gray darken-4"
    },
    on: {
      "click": function($event) {
        _vm.showPanelsDistribution = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "gray darken-4"
    }
  }, [_vm._v("keyboard_arrow_up")]), _vm._v(" Hide Panels Distribution"), _c('v-icon', {
    attrs: {
      "color": "gray darken-4"
    }
  }, [_vm._v("keyboard_arrow_up")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('center', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.ChangePanelsDefinition($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('center', [_c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closePanelsDefinitionEdit($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  })], 1), _vm._v(" "), _c('br')], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "-12px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    },
    on: {
      "click": _vm.clickedTopPanelFilters
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "slot": "activator",
      "color": "green",
      "label": "Specific",
      "value": "specific"
    },
    slot: "activator",
    model: {
      value: (_vm.selectedPanelFilters),
      callback: function($$v) {
        _vm.selectedPanelFilters = $$v
      },
      expression: "selectedPanelFilters"
    }
  }), _vm._v(" "), _c('span', [_c('center', [_c('i', [_vm._v("Less than " + _vm._s(_vm.lowerLimitProps) + " genes")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "max-width": "35% !important"
    },
    attrs: {
      "xs4": "",
      "sm4": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "slot": "activator",
      "color": "amber accent-4",
      "label": "Moderate",
      "value": "moderate"
    },
    slot: "activator",
    model: {
      value: (_vm.selectedPanelFilters),
      callback: function($$v) {
        _vm.selectedPanelFilters = $$v
      },
      expression: "selectedPanelFilters"
    }
  }), _vm._v(" "), _c('span', [_c('center', [_c('i', [_vm._v("More than " + _vm._s(_vm.lowerLimitProps) + " genes & Less than " + _vm._s(_vm.upperLimitProps) + " genes")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md6": "",
      "lg4": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "slot": "activator",
      "color": "red",
      "label": "General",
      "value": "general"
    },
    slot: "activator",
    model: {
      value: (_vm.selectedPanelFilters),
      callback: function($$v) {
        _vm.selectedPanelFilters = $$v
      },
      expression: "selectedPanelFilters"
    }
  }), _vm._v(" "), _c('span', [_c('center', [_c('i', [_vm._v("More than " + _vm._s(_vm.upperLimitProps) + " genes")])])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.selectedPanelsInCheckBox.length))]), _vm._v(" of panels " + _vm._s(_vm.multiSelectPanels.length) + " selected\n                               ")]), _vm._v(" "), (_vm.multiSelectPanels.length) ? _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "panelssvgbar",
      "selectedNumber": _vm.selectedPanelsInCheckBox.length,
      "totalNumber": _vm.multiSelectPanels.length
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chartComponent !== 'GeneMembership'),
      expression: "chartComponent!=='GeneMembership'"
    }],
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showChartComponent('GeneMembership')
      }
    }
  }, [_vm._v("\n                                 View & Filter\n                               ")])], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "inActiveVendorsCard"
    }
  }, [_c('div', {
    staticClass: "mb-3",
    attrs: {
      "id": "activeVendorsCard"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.diseasesProps.length && _vm.modeOfInheritanceProps.length && _vm.multiSelectItems.length > 0) ? _c('div', [_c('v-card', {
    class: [_vm.chartComponent === 'Vendors' ? 'activeCardBox elevation-5' : 'rightbarCard ']
  }, [_c('v-card-text', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('center', [_c('span', {
    staticClass: "Rightbar_CardHeading"
  }, [_vm._v("\n                                VENDORS\n                              ")]), _vm._v(" "), _c('Dialogs', {
    staticClass: "dialogBox",
    attrs: {
      "id": "vendorsDialog",
      "HeadlineText": _vm.HelpDialogsData[4].HeadlineText,
      "ContentText": _vm.HelpDialogsData[4].Content
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "Rightbar_card_divider"
  }), _vm._v(" "), _c('div', [(_vm.multiSelectItems.length > 1) ? _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v(_vm._s(_vm.vendorsSelect.length))]), _vm._v(" of " + _vm._s(_vm.multiSelectItems.length) + " vendors selected\n                                  ")]), _vm._v(" "), _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBoxInside",
      "selectedNumber": _vm.vendorsSelect.length,
      "totalNumber": _vm.multiSelectItems.length
    }
  })], 1) : (_vm.multiSelectItems.length < 2) ? _c('div', [(_vm.selectedPanelsInCheckBox.length > 0) ? _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v("1")]), _vm._v(" of 1 vendor selected\n                                    ")]), _vm._v(" "), _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBoxInside",
      "selectedNumber": 1,
      "totalNumber": 1
    }
  })], 1) : (_vm.selectedPanelsInCheckBox.length < 1) ? _c('div', [_c('span', {
    staticClass: "Rightbar_card_content_subheading"
  }, [_c('strong', {
    staticClass: "Rightbar_card_content_heading"
  }, [_vm._v("0")]), _vm._v(" of 1 vendor selected\n                                    ")]), _vm._v(" "), _c('SvgBar', {
    staticClass: "SvgBarClass",
    attrs: {
      "id": "disordersSvgBoxInside",
      "selectedNumber": 0,
      "totalNumber": 1
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chartComponent !== 'Vendors'),
      expression: "chartComponent!=='Vendors'"
    }],
    staticClass: "viewFilterButton",
    attrs: {
      "outline": "",
      "color": "primary darken-1",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showChartComponent('Vendors')
      }
    }
  }, [_vm._v("View & Filter")])], 1)], 1)], 1)], 1)], 1) : _vm._e()])], 1)], 1)])])], 1)], 1), _vm._v(" "), (_vm.diseases.length && _vm.removeSearchTermFlag === false) ? _c('v-flex', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0px"
    },
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Disorders")]), _vm._v(" "), _c('v-card-text', [(_vm.diseases.length && _vm.removeSearchTermFlag === false) ? _c('disease-panel', {
    attrs: {
      "DiseasePanelData": _vm.diseases,
      "selectedDisordersProps": _vm.selectDisordersProps,
      "selectedModesOfInheritance": _vm.selectedModesOfInheritanceProps
    },
    on: {
      "selectedDiseases": function($event) {
        _vm.selectDiseases($event)
      },
      "setDisorderNamesList": function($event) {
        _vm.updateDisorderNamesList($event)
      },
      "PieChartSelectorData": function($event) {
        _vm.PieChartSelectorData($event)
      },
      "ModesSelectedData": function($event) {
        _vm.ModesSelectedData($event)
      },
      "disordersSelectedData": function($event) {
        _vm.disordersSelectedData($event)
      }
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.diseasesProps.length) ? _c('v-flex', {
    staticStyle: {
      "visibility": "hidden",
      "height": "0px"
    },
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Panels")]), _vm._v(" "), _c('v-card-text', [(_vm.diseasesProps.length) ? _c('gene-panel', {
    attrs: {
      "DiseasePanelData": _vm.diseasesProps,
      "selectedVendorsProps": _vm.vendorsSelectProps,
      "selectedPanelsInCheckBox": _vm.selectedPanelsInCheckBoxProps,
      "selectedPanelsInCheckBoxPropsOne": _vm.selectedPanelsInCheckBoxPropsOne,
      "lowerLimitProps": _vm.lowerLimitProps,
      "upperLimitProps": _vm.upperLimitProps,
      "selectedPanelFilters": _vm.selectedPanelFilters
    },
    on: {
      "selectedPanels": function($event) {
        _vm.selectPanels($event)
      },
      "NoOfPanels": function($event) {
        _vm.NoOfPanels($event)
      },
      "setVendorList": function($event) {
        _vm.updateVendorList($event)
      },
      "setPanelsNamesList": function($event) {
        _vm.setPanelsNamesList($event)
      },
      "selectVendors": function($event) {
        _vm.selectVendors($event)
      },
      "selectPanelsFromVendorsUpdate": function($event) {
        _vm.selectPanelsFromVendorsUpdate($event)
      }
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66bcfb58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/pages/GeneticTestingRegistry.vue
// module id = 510
// module chunks = 0